var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isEmpty } from 'lodash-es';
import http, { Q, Api } from '@http';
import { observable, action, runInAction, computed, reaction } from 'mobx';
import { PredefinePriority, SessionKey, EScheduleServiceType } from '@common/enums/base';
import moment from 'moment';
import { currentClientId, isIH } from '@common/utils/userProfile';
import Cookies from 'js-cookie';
import { getLocationId } from '@common/utils';
var AutoScheduleWithLastVersionStore = /** @class */ (function () {
    function AutoScheduleWithLastVersionStore(parent) {
        this.isShowPushOut = false;
        this.canPushOut = false;
        this.weathers = [];
        this.scheduleLoading = false;
        this.noAvailableChecked = false;
        this.radioSelectValue = EScheduleServiceType.PullIn;
        this.parent = parent;
        this.init();
    }
    AutoScheduleWithLastVersionStore.prototype.bundlePriority = function () {
        return (this.parent.isAutoSchedule &&
            this.parent.serviceCodeId &&
            this.parent.priority);
    };
    AutoScheduleWithLastVersionStore.prototype.init = function () {
        var _this = this;
        reaction(function () {
            return {
                priority: _this.bundlePriority(),
                isLastVersionAutoSchedule: _this.parent.isLastVersionAutoSchedule
            };
        }, function (result) {
            if (result.priority && result.isLastVersionAutoSchedule) {
                _this.render();
            }
        });
    };
    AutoScheduleWithLastVersionStore.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.parent.getRegionScript()];
                    case 1:
                        _a.sent();
                        this.setScheduleLoading(true);
                        this.setSelectedSchedule(null);
                        return [4 /*yield*/, this.getScheduleTimeBlocks()];
                    case 2:
                        _a.sent();
                        this.getWeatherForecastByTime();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AutoScheduleWithLastVersionStore.prototype, "isShowUpcomming", {
        get: function () {
            if (this.isShowPushOut) {
                return false;
            }
            return this.isExistVisit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoScheduleWithLastVersionStore.prototype, "isExistVisit", {
        get: function () {
            if (!this.autoScheduleRawData) {
                return false;
            }
            var top3 = this.autoScheduleRawData.pullInRecommend.topRecommends;
            var hasTechnician = top3.length > 0;
            if (!hasTechnician)
                return false;
            var hasVisit = top3[0].visitId > 0;
            if (!hasVisit && hasTechnician) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoScheduleWithLastVersionStore.prototype, "isShowPullIn", {
        get: function () {
            return !this.isShowPushOut;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoScheduleWithLastVersionStore.prototype, "scheduleTimeBlocks", {
        get: function () {
            var autoScheduleData = this.autoScheduleRawData;
            if (!(autoScheduleData && autoScheduleData.pullInRecommend)) {
                return [];
            }
            autoScheduleData.pullInRecommend.topRecommends.map(function (x) {
                x.isRecommend = true;
            });
            autoScheduleData.pullInRecommend.recommends.map(function (x) {
                x.isRecommend = false;
            });
            var result = Array();
            if (this.canPushOut && this.isShowPushOut) {
                if (autoScheduleData.pushOutRecommend) {
                    result = [autoScheduleData.pushOutRecommend];
                }
            }
            else {
                result = __spreadArrays(autoScheduleData.pullInRecommend.topRecommends, autoScheduleData.pullInRecommend.recommends);
            }
            sessionStorage.setItem(SessionKey.ScheduleListAllNoCanSelectWithLastVersion, "" + result.every(function (x) { return !x.canSelect; }));
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoScheduleWithLastVersionStore.prototype, "showNoAffiliatesCheck", {
        get: function () {
            if (this.parent.priority !== PredefinePriority.NextAvailableService) {
                return false;
            }
            if (this.scheduleTimeBlocks.every(function (x) { return !x.canSelect; })) {
                return false;
            }
            return (this.scheduleTimeBlocks.filter(function (x) { return x.canSelect && x.isHighlight; }).length >
                0);
        },
        enumerable: false,
        configurable: true
    });
    AutoScheduleWithLastVersionStore.prototype.setScheduleLoading = function (loading) {
        this.scheduleLoading = loading;
    };
    AutoScheduleWithLastVersionStore.prototype.setSelectedSchedule = function (schdule) {
        this.selectedSchedule = schdule;
    };
    AutoScheduleWithLastVersionStore.prototype.toggleNoAvailableChecked = function () {
        this.noAvailableChecked = !this.noAvailableChecked;
    };
    AutoScheduleWithLastVersionStore.prototype.formatData = function (rawData) {
        if (this.parent.isLastVersionAutoSchedule && !isIH()) {
            // @ts-ignore
            rawData.pullInRecommend.recommendByDays = rawData.pullInRecommend.recommends;
        }
    };
    AutoScheduleWithLastVersionStore.prototype.getScheduleTimeBlocks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientId, priorityId, param;
            var _this = this;
            return __generator(this, function (_a) {
                clientId = Cookies.get('clientId');
                priorityId = this.parent.isPriorityBeRegionScriptModify ? this.parent.regionScriptPriority : this.parent.priority;
                param = {
                    serviceCodeId: this.parent.serviceCodeId,
                    priorityId: priorityId,
                    locationId: Number(this.parent.locationId) || getLocationId(),
                    canScheduleInWeekend: false,
                    clientId: clientId,
                    startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    residentId: Cookies.get("residentId")
                };
                return [2 /*return*/, this.api()
                        .getAutoScheduleData(param)
                        .then(function (rawData) {
                        if (rawData) {
                            runInAction(function () {
                                _this.formatData(rawData);
                                _this.autoScheduleRawData = rawData;
                                _this.initPushout();
                                _this.checkUrgentIHTNoRecommendData(rawData);
                            });
                        }
                        _this.setScheduleLoading(false);
                    })
                        .catch(function () {
                        _this.setScheduleLoading(false);
                    })];
            });
        });
    };
    AutoScheduleWithLastVersionStore.prototype.checkUrgentIHTNoRecommendData = function (rawData) {
        var priorityId = this.parent.isPriorityBeRegionScriptModify ? this.parent.regionScriptPriority : this.parent.priority;
        var noRecommendData = isEmpty(rawData) ||
            (rawData &&
                isEmpty(rawData.pushOutRecommend) &&
                isEmpty(rawData.pullInRecommend.topRecommends) &&
                isEmpty(rawData.pullInRecommend.recommends));
        if (isIH() && this.parent.isInHouseTechnician && priorityId === PredefinePriority.NextAvailableService && noRecommendData) {
            this.parent.urgentIHTNoRecommendSpecificProcess = true;
        }
        else {
            this.parent.urgentIHTNoRecommendSpecificProcess = false;
        }
    };
    AutoScheduleWithLastVersionStore.prototype.initPushout = function () {
        if (this.autoScheduleRawData.pushOutRecommend) {
            this.isShowPushOut = true;
            this.canPushOut = true;
            this.radioSelectValue = EScheduleServiceType.PushOut;
            this.setSelectedSchedule(this.autoScheduleRawData.pushOutRecommend);
        }
        else {
            this.radioSelectValue = EScheduleServiceType.PullIn;
            this.isShowPushOut = false;
            this.canPushOut = false;
        }
    };
    AutoScheduleWithLastVersionStore.prototype.togglePushout = function () {
        if (this.isShowPushOut) {
            this.isShowPushOut = false;
            this.setSelectedSchedule(null);
        }
        else {
            this.isShowPushOut = true;
            this.setSelectedSchedule(this.autoScheduleRawData.pushOutRecommend);
        }
    };
    AutoScheduleWithLastVersionStore.prototype.radioSelectValueSet = function (e) {
        this.radioSelectValue = e;
        switch (this.radioSelectValue) {
            case EScheduleServiceType.PullIn:
                this.isShowPushOut = false;
                this.setSelectedSchedule(null);
                break;
            case EScheduleServiceType.PushOut:
                this.isShowPushOut = true;
                this.setSelectedSchedule(this.autoScheduleRawData.pushOutRecommend);
                break;
            default:
                break;
        }
    };
    AutoScheduleWithLastVersionStore.prototype.getWeatherForecastByTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dates, totalDays, day, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.weathers && this.weathers.length > 0) {
                            return [2 /*return*/];
                        }
                        dates = [];
                        totalDays = 16;
                        day = -1;
                        do {
                            dates.push(moment
                                .utc()
                                .add(day, 'day')
                                .format('YYYY-MM-DD'));
                            day = day + 1;
                        } while (day < totalDays);
                        return [4 /*yield*/, this.api().getWeatherForecastByTime(dates)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.weathers = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AutoScheduleWithLastVersionStore.prototype.saveToSession = function () {
        var selectedSchedule = this.selectedSchedule;
        if (!selectedSchedule)
            return;
        this.autoScheduleModel = {
            scheduleStartTime: selectedSchedule.scheduleStartTime,
            scheduleEndTime: selectedSchedule.scheduleEndTime,
            affiliateId: selectedSchedule.affiliateId,
            technicianScores: selectedSchedule.technicianScores,
            visitId: selectedSchedule.visitId,
            isExistVisit: this.isExistVisit,
            isSelectPushOutTechnician: Number(this.radioSelectValue) === EScheduleServiceType.PushOut,
            recommendKey: this.autoScheduleRawData.recommendKey,
            submissionPayload: __assign(__assign({}, this.autoScheduleRawData.submissionPayload), { scheduleRecommendItem: selectedSchedule })
        };
        sessionStorage.setItem(SessionKey.AutoScheduleModelWithLastVersion, JSON.stringify(this.autoScheduleModel));
        sessionStorage.setItem(SessionKey.SelectedScheduleWithLastVersion, JSON.stringify(this.selectedSchedule));
    };
    AutoScheduleWithLastVersionStore.prototype.canSchedule = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function () {
            var selectedSchedule, canSchedule, error_1;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!!isIH()) return [3 /*break*/, 4];
                        selectedSchedule = this.selectedSchedule;
                        if (!selectedSchedule)
                            return [2 /*return*/, true];
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api().canScheduleBySO({
                                locationId: getLocationId(),
                                clientId: currentClientId(),
                                visitId: (_a = this.autoScheduleModel) === null || _a === void 0 ? void 0 : _a.visitId,
                                isSelectPushOutTechnician: (_b = this.autoScheduleModel) === null || _b === void 0 ? void 0 : _b.isSelectPushOutTechnician,
                                rank: (_c = this.autoScheduleModel) === null || _c === void 0 ? void 0 : _c.rank,
                                isExistVisit: (_d = this.autoScheduleModel) === null || _d === void 0 ? void 0 : _d.isExistVisit,
                                startTime: (_e = this.autoScheduleModel) === null || _e === void 0 ? void 0 : _e.scheduleStartTime,
                                endTime: (_f = this.autoScheduleModel) === null || _f === void 0 ? void 0 : _f.scheduleEndTime,
                                serviceCodeId: this.parent.serviceCodeId,
                                priorityId: this.parent.isPriorityBeRegionScriptModify ? this.parent.regionScriptPriority : this.parent.priority,
                                technicianIds: ((_g = this.autoScheduleModel) === null || _g === void 0 ? void 0 : _g.technicianScores) && ((_h = this.autoScheduleModel.technicianScores) === null || _h === void 0 ? void 0 : _h.map(function (x) { return x.technicianId; }))
                            })];
                    case 2:
                        canSchedule = _j.sent();
                        if (canSchedule === false) {
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _j.sent();
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AutoScheduleWithLastVersionStore.prototype.loadFromSession = function () {
        var value = sessionStorage.getItem(SessionKey.AutoScheduleModelWithLastVersion);
        this.autoScheduleModel = value ? JSON.parse(value) : null;
        var select = sessionStorage.getItem(SessionKey.SelectedScheduleWithLastVersion);
        this.selectedSchedule = value ? JSON.parse(select) : null;
    };
    AutoScheduleWithLastVersionStore.prototype.cleanSession = function () {
        sessionStorage.removeItem(SessionKey.AutoScheduleModelWithLastVersion);
        sessionStorage.removeItem(SessionKey.ScheduleListAllNoCanSelectWithLastVersion);
        sessionStorage.removeItem(SessionKey.SelectedScheduleWithLastVersion);
    };
    AutoScheduleWithLastVersionStore.prototype.cleanData = function () {
        this.autoScheduleModel = null;
        this.selectedSchedule = null;
    };
    AutoScheduleWithLastVersionStore.prototype.getWeatherByTime = function (date) {
        return (this.weathers.find(function (weather) {
            return moment.utc(weather.date).format('YYYY-MM-DD') ===
                moment(date).format('YYYY-MM-DD');
        }) || {});
    };
    AutoScheduleWithLastVersionStore.prototype.api = function () {
        var _this = this;
        return {
            getAutoScheduleData: function (params) {
                if (_this.parent.isLastVersionAutoSchedule && !isIH()) {
                    return Q(http.get("/ScheduleOptimization/schedule/wo", {
                        params: params
                    }));
                }
                return Q(http.get("VisitAutoSchedule/GetWorkOrderRecommendTechnicians", {
                    params: params
                }));
            },
            canScheduleBySO: function (params) {
                return Q(http.post("/ScheduleOptimization/can-schedule", params));
            },
            getWeatherForecastByTime: function (dates) {
                return Q(http.post('RSP/NewRequest/GetWeatherForecastByTime', { times: dates }, Api.withForm));
            }
        };
    };
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "autoScheduleRawData", void 0);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "isShowPushOut", void 0);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "canPushOut", void 0);
    __decorate([
        computed
    ], AutoScheduleWithLastVersionStore.prototype, "isShowUpcomming", null);
    __decorate([
        computed
    ], AutoScheduleWithLastVersionStore.prototype, "isExistVisit", null);
    __decorate([
        computed
    ], AutoScheduleWithLastVersionStore.prototype, "isShowPullIn", null);
    __decorate([
        computed
    ], AutoScheduleWithLastVersionStore.prototype, "scheduleTimeBlocks", null);
    __decorate([
        computed
    ], AutoScheduleWithLastVersionStore.prototype, "showNoAffiliatesCheck", null);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "weathers", void 0);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "scheduleLoading", void 0);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "setScheduleLoading", null);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "selectedSchedule", void 0);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "setSelectedSchedule", null);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "noAvailableChecked", void 0);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "toggleNoAvailableChecked", null);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "getScheduleTimeBlocks", null);
    __decorate([
        action.bound
    ], AutoScheduleWithLastVersionStore.prototype, "initPushout", null);
    __decorate([
        action.bound
    ], AutoScheduleWithLastVersionStore.prototype, "togglePushout", null);
    __decorate([
        observable
    ], AutoScheduleWithLastVersionStore.prototype, "radioSelectValue", void 0);
    __decorate([
        action.bound
    ], AutoScheduleWithLastVersionStore.prototype, "radioSelectValueSet", null);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "getWeatherForecastByTime", null);
    __decorate([
        action.bound
    ], AutoScheduleWithLastVersionStore.prototype, "canSchedule", null);
    __decorate([
        action
    ], AutoScheduleWithLastVersionStore.prototype, "cleanData", null);
    return AutoScheduleWithLastVersionStore;
}());
export default AutoScheduleWithLastVersionStore;
